import styled, { css } from 'styled-components';
import LoaderSvg from './images/loaderBig.svg';

export const Loader = styled.div`
    position: relative;
    min-height: 200px;
    min-width: 200px;
    width: 100%;
    margin-bottom: 30px;

    &:after {
        content: ' ';
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 999;
        top: 0;
        left: 0;
        background-image: url(${LoaderSvg});
        background-position: 50% 50%;
        background-size: auto;
        background-repeat: no-repeat;
        transition: all 0.3s ease;
    }

    ${({ active }) => active && css`
        &:after,
        &:before {
            opacity: 1;
            visibility: visible;
        }
    `}

    ${({ dark, theme }) => dark && css`
        &:after {
            display: none;
        }
        &:before {
            border: 3px solid #f3f3f3; /* Light grey */
            border-top: 3px solid ${theme.colors.Color2};
            border-radius: 50%;
            width: 30px;
            height: 30px;
            animation: spin 2s linear infinite;
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -15px 0 0 -15px;
            z-index: 600;

            content: ' ';
            display: block;

            transition: all 0.2s ease;
        }
    `}

    ${({ main, theme }) => main && css`
        &:before {
            border-top: 3px solid ${theme.colors.Color2};
        }
    `}

    ${({ fullHeight }) => fullHeight && css`
        height: 100vh;
        &:after {
            background-position: top;
            z-index: 3;
        }
    `}
`;

export const Root = styled.div`
    position: relative;
    width: 100%;
`;
